import * as helpers from './_helpers';
import {
  CookieManager
} from './_cookieManager';

const goBackTo = document.referrer;

helpers.ready(() => {
  CookieManager.removeGACookies();
  CookieManager.setMeasurmentId(false);
  CookieManager.setUpCookies();
  const yesSaveGame = document.querySelector('#yes-save');
  const noSaveGame = document.querySelector('#no-save');

  if (CookieManager.hasChoiceBeenMade()) {
    const body = document.querySelectorAll('body');
    body[0].classList.add('choice-made');
    const preTitle = document.querySelector('#pre-title');
    preTitle.innerHTML = 'Cookie settings';

    if (CookieManager.playingWithSavedData()) {
      noSaveGame.classList.remove('active');
      noSaveGame.classList.remove('icon-checkbox-check');
      yesSaveGame.classList.add('active');
      yesSaveGame.classList.add('icon-checkbox-check');
    }
    else {
      yesSaveGame.classList.remove('active');
      yesSaveGame.classList.remove('icon-checkbox-check');
      noSaveGame.classList.add('active');
      noSaveGame.classList.add('icon-checkbox-check');
    }
  }

  yesSaveGame.addEventListener('click', () => {
    CookieManager.playWithSaveData();
    noSaveGame.classList.remove('active');
    noSaveGame.classList.remove('icon-checkbox-check');
    yesSaveGame.classList.add('active');
    yesSaveGame.classList.add('icon-checkbox-check');
    window.location = goBackTo;
  });

  noSaveGame.addEventListener('click', () => {
    CookieManager.playWithOutSaveData();
    yesSaveGame.classList.remove('active');
    yesSaveGame.classList.remove('icon-checkbox-check');
    noSaveGame.classList.add('active');
    noSaveGame.classList.add('icon-checkbox-check');
    window.location = goBackTo;
  });
});
